import MainLayout from "../layout/MainLayout";
import { ToggleButton, Button2, QuickActionSelect } from "../Components";
import QrPay from "../Components/qr-payment/QrPay";
import QrReceive from "../Components/qr-payment/QrReceive";
import { useState } from "react";
const componentForTab = (tab) =>
  tab === "QR Receive" ? <QrReceive /> : <QrPay />;

const QrPayment = ({ initialTab = "QR Pay" }) => {
  const [selectedComponent, setSelectedComponent] = useState(
    componentForTab(initialTab)
  );

  const onToggle = (value) => {
    switch (value) {
      case "QR Pay":
        setSelectedComponent(<QrPay />);
        break;
      case "QR Receive":
        setSelectedComponent(<QrReceive />);
        break;
      default:
        setSelectedComponent(<QrPay />);
    }
  };
  return (
    <MainLayout
      expand={false}
      NavName="QR Payment"
      navbarChildren={
        <QuickActionSelect />
      }
    >
      <div>


        <div className="container mt-5">
          <div className="d-flex justify-content-between align-items-center">
            <ToggleButton
              options={["QR Pay", "QR Receive"]}
              defaultValue={initialTab}
              onChange={(value) => onToggle(value)}
            />
            <Button2 buttonName={"Request Payment"} className={"btn-dark"} />
          </div>

          <div className="border rounded-3 p-3 mt-3">
            <div
              className="border rounded-3  overflow-auto"
              style={{ height: "70vh" }}
            >
              {selectedComponent}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default QrPayment;
